module["exports"] = ["(9##)###-##-##"];